import { render } from "./AposDocsManager.vue?vue&type=template&id=2473633f&scoped=true"
import script from "./AposDocsManager.vue?vue&type=script&lang=js"
export * from "./AposDocsManager.vue?vue&type=script&lang=js"

import "./AposDocsManager.vue?vue&type=style&index=0&id=2473633f&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2473633f"],['__file',"piece-type/ui/apos/components/AposDocsManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2473633f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2473633f', __exports__)) {
    api.reload('2473633f', __exports__)
  }
  
  module.hot.accept("./AposDocsManager.vue?vue&type=template&id=2473633f&scoped=true", () => {
    api.rerender('2473633f', render)
  })

}


export default __exports__